import React from "react";

import JobPage from "./JobPage";

const FullstackEngineer = () => (
    <JobPage
        title="Engineering Manager & IT Officer"
        location="Malta"
        status="closed"
        statusNote="Published September 30, 2025 — Expired November 24, 2025"
        summary={[
            "Develop in Go and React using best practices.",
            "Write clean code with unit tests.",
            "Work closely with the product development team to deliver on assigned tasks.",
            "Raise issues encountered during development with peers and stakeholders.",
            "Work in an agile environment and provide progress reports through sprint and scrum principles.",
            "Collaborate with fellow developers to deliver the best possible design and solution.",
            "Coordinate with other departments to remove blockers.",
        ]}
        tldrIntro="Don't read this unless you know"
        tldr={[
            "You have a proven track record of shipping high-quality code on time.",
            "You eat and breathe great user experiences.",
            "You enjoy moving across the stack, frontend and backend.",
            "You've built financial-services applications with Go. Bonus points for Java, Python, Ruby, etc.",
            "You have a deep understanding of microservices architectures, and you've built web apps with React, Angular, or Vue. Did we mention React?",
            "You know a thing or two about DeFi applications.",
        ]}
        requirements={[
            "3+ years' experience designing and developing payment processing & financial transaction solutions.",
            "Familiarity with modern software engineering tools (build tools, unit testing, test automation, CI, etc.).",
            "Strong knowledge of HTTP, REST APIs, and designing web services / microservices.",
            "BS or higher in Computer Science or related discipline (or equivalent experience).",
            "Experience in banking, payment processing, forex, brokerage services, and/or crypto.",
            "Proven track record of delivering on time, to specification.",
            "Experience with Agile methodologies and DevOps.",
            "Self-starter with a can-do attitude.",
            "Comfortable evaluating new technologies and weighing tradeoffs.",
        ]}
        experienceNeeded={["Go experience.", "JavaScript framework experience (React, Vue, Angular)."]}
        desiredExperience={[
            "Web3 experience is a plus.",
            "Financial services, brokerage, or crypto background.",
            "SEPA / ACH / NPP / PSD2 experience. eKYC, remote onboarding, and remote enrollment a plus.",
        ]}
    />
);

export default FullstackEngineer;
